import tippy from 'tippy.js';
import Cookies from 'js-cookie';

export default class Overlay {
  constructor(config) {
    this.config = {
      ...config,
    };
    this.hasGlobalConsent = false;
    this.cookieName = this.config.consentCookieName;
    this.$el = this.config.$el;
    this.$headline = this.$headline;
    this.$text = this.$text;
    this.$checkbox = this.$el.querySelector('.checkbox__input');
    this.$buttonCancel = this.$buttonCancel;
    this.$buttonSubmit = this.$buttonSubmit;
    this.$template = this.$el.querySelector('.js-overlay-template');
    this.providerName = this.config.providerName;
    this.smallOverlay = false;

    if (this.getConsentCookie(this.cookieName) === 'accept') {
      this.hasGlobalConsent = true;
    }

    window.addEventListener('resize', () => {
      this.destroy();
      this.detectOverlayWidth();
      this.initOverlay();
    });
    window.addEventListener('selectTab', () => {
      this.destroy();
      this.detectOverlayWidth();
      this.initOverlay();
    });

    this.detectOverlayWidth();
  }

  detectOverlayWidth = () => {
    if (((this.config.$el.offsetHeight * this.config.$el.offsetWidth) / 1000) < 150) {
      this.smallOverlay = true;
    } else {
      this.smallOverlay = false;
    }
  }

  setOverlaySize = () => {
    const $overlay = this.$el.querySelector('.overlay');

    if (this.smallOverlay) {
      const $tooltipText = this.$el.querySelector('.overlay__text .text');
      const $tooltipIcon = this.$el.querySelector('.overlay__tooltip-icon');

      if ($overlay) {
        $overlay.classList.add('overlay--mini');
      }

      if ($tooltipIcon) {
        tippy($tooltipIcon, {
          content: $tooltipText ? $tooltipText.innerHTML : '',
          allowHTML: true,
          hideOnClick: 'toggle',
          interactive: true,
          appendTo: 'parent',
        });
      }
    } else if ($overlay) {
      $overlay.classList.remove('overlay--mini');
    }
  }

  getConsentCookie(name) {
    const value = `;${document.cookie}`;
    const parts = value.split(`;${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
    return null;
  }

  init() {
    if (this.getConsentCookie(this.config.consentCookieName) === 'accept') {
      this.hasGlobalConsent = true;
    }
    if (!this.hasGlobalConsent) {
      this.initOverlay();
    } else {
      this.consent();
    }
  }

  initOverlay(create = true) {
    if (!this.$el) {
      const $overlays = document.querySelectorAll('.js-overlay');
      $overlays.forEach(($overlay) => {
        // remove overlay
        if ($overlay && $overlay.parentNode && !create) {
          $overlay.parentNode.removeChild($overlay, $overlay.parentNode);
        }
      });
    } else if (this.$el) {
      const $overlayCurrent = this.$el.querySelector('.js-overlay');
      if ($overlayCurrent) {
        $overlayCurrent.parentNode.removeChild($overlayCurrent, $overlayCurrent.parentNode);
      }
    }

    if (this.$template && create) {
      // insert overlay from template
      const $clone = document.importNode(this.$template.content, true);
      if (this.$template.parentNode) {
        this.$template.parentNode.appendChild($clone);
      }

      // add button / checkbox events
      this.$decline = this.$el.querySelector('.js-overlay-decline');
      this.$consent = this.$el.querySelector('.js-overlay-consent');
      this.cookieName = this.$el.querySelector('.js-overlay-global-consent');

      this.setOverlaySize();

      window.addEventListener('resize', () => {
        this.setOverlaySize();
      });


      if (this.$decline) {
        this.$decline.addEventListener('click', this.declineConsent);
      }

      if (this.$consent) {
        this.$consent.addEventListener('click', this.consent);
      }

      // MISSING DESCRIPTION: Focus trap
      const $openOverlay = this.$el.querySelector('.js-overlay');
      if ($openOverlay) {
        $openOverlay.querySelector('.overlay__headline').setAttribute('tabindex', '0');
      }

      if (this.config.onOverlayInit) {
        this.config.onOverlayInit();
      }
    }
  }

  destroy() {
    this.initOverlay(false);
  }

  declineConsent = (event) => {
    if (event) {
      event.stopPropagation();
    }
    if (this.config.onDecline) {
      this.config.onDecline();
    }
    this.initOverlay(false);
  }

  consent = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const hasGlobalConsentOption = this.$el.querySelector('.checkbox__input');
    const hasCheckedGlobalConsent = hasGlobalConsentOption && this.$el.querySelector('.checkbox__input').checked;

    if (hasGlobalConsentOption && hasCheckedGlobalConsent) {
      // If global consent is checked, then add cookie
      // document.cookie = `${this.config.consentCookieName}=accept`;
      Cookies.set(this.config.consentCookieName, 'accept', { path: '/' });
      this.hasGlobalConsent = true;
      if (this.config.onGlobalConsent) {
        this.config.onGlobalConsent();
      }
    } else if (this.config.onConsent) {
      this.config.onConsent(event);
    }

    // Close overlay on consent
    this.initOverlay(false);
    this.$template.remove();
  }
}
